/**
 * Firebase initialization
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
let app = null;
let auth = null;
/**
 * Initialize Firebase
 */
export function initializeFirebase(config) {
    if (app) {
        return; // Already initialized
    }
    const firebaseConfig = {
        apiKey: config.apiKey,
        authDomain: config.authDomain,
        projectId: config.projectId,
        appId: config.appId,
        ...(config.storageBucket && { storageBucket: config.storageBucket }),
        ...(config.messagingSenderId && { messagingSenderId: config.messagingSenderId }),
    };
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
}
/**
 * Get Firebase Auth instance
 */
export function getFirebaseAuth() {
    if (!auth) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return auth;
}
/**
 * Get Firebase App instance
 */
export function getFirebaseApp() {
    if (!app) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return app;
}
//# sourceMappingURL=firebase.js.map